import * as Languages from '@cospired/i18n-iso-languages';
import danish from '@cospired/i18n-iso-languages/langs/da.json';
import toTitleCase from '@smart-tv/utils/string/to-title-case';

Languages.registerLocale(danish);

export const formatLanguage = (language: string) => {
  try {
    const languageName = Languages.getName(language.toLowerCase(), 'da');
    if (languageName) {
      return toTitleCase(languageName);
    }
  } catch (error) {
    console.error('Error getting language name:', error);
  }
  return '';
};

export default formatLanguage;
